import { useQuery } from "@tanstack/react-query"

import {
  getCooperative,
  getCooperativeKpis,
  listCooperatives,
} from "@/features/cooperatives/api/cooperatives.api"

export const cooperativesKeys = {
  all: ["cooperatives"] as const,
  list: () => [...cooperativesKeys.all, "list"] as const,
  detail: (id: string) => [...cooperativesKeys.all, "detail", id] as const,
  kpis: (groupId: string | number) =>
    [...cooperativesKeys.all, "kpis", String(groupId)] as const,
}

export function useCooperatives() {
  return useQuery({
    queryKey: cooperativesKeys.list(),
    queryFn: listCooperatives,
  })
}

export function useCooperative(cooperativeId: string) {
  return useQuery({
    queryKey: cooperativesKeys.detail(cooperativeId),
    queryFn: () => getCooperative(cooperativeId),
    enabled: Boolean(cooperativeId),
  })
}

export function useCooperativeKpis(groupId: string | number | undefined) {
  return useQuery({
    queryKey: cooperativesKeys.kpis(groupId ?? ""),
    queryFn: () => getCooperativeKpis(groupId as string | number),
    enabled: Boolean(groupId),
  })
}
